import React from 'react';

import {Button, Modal, Pill} from 'ui-kit';

import * as styles from './PlanHistoryModal.module.css';

const formatDate = new Intl.DateTimeFormat('en-US').format;

export function PlanHistoryModal({
  show,
  onDismiss,
  subscriptions,
  firstName,
  lastName,
}) {
  return (
    <Modal show={show} onDismiss={onDismiss}>
      <h2 className={styles.Heading}>
        Plan history for {firstName} {lastName}
      </h2>

      {subscriptions.length === 0 ? (
        <p>This member has no plan history.</p>
      ) : (
        subscriptions.map(subscription => {
          return (
            <div key={subscription.id} className={styles.Subscription}>
              <div>
                <p className={styles.PlanTitle}>
                  <strong>{subscription.membershipPlan.title}</strong>
                </p>
                <p>
                  Active from {formatDate(new Date(subscription.startDate))} to{' '}
                  {formatDate(new Date(subscription.endDate))}
                </p>
              </div>

              <div>
                {subscription.status === 'ACTIVE' ? (
                  <Pill color="green">Active</Pill>
                ) : (
                  <Pill color="red">Expired</Pill>
                )}
              </div>
            </div>
          );
        })
      )}

      <div className={styles.Footer}>
        <Button type="button" onClick={onDismiss} color="light">
          Close
        </Button>
      </div>
    </Modal>
  );
}
